module.exports = __webpack_public_path__ + "img/roundVideoBtn.fe7ee5ff.svg";